import { useTranslation } from "react-i18next";
import { Settings, Link2, HelpCircle } from "lucide-react";
import type { SchedulerGlobalPresets } from "@shared/schema";
import { PresetSection, PresetToggle } from "./PresetSection";

export function GlobalPresets({
  value,
  onChange,
}: {
  value: SchedulerGlobalPresets;
  onChange: (next: SchedulerGlobalPresets) => void;
}) {
  const { t } = useTranslation();
  return (
    <PresetSection
      icon={<Settings size={14} className="text-white/60" />}
      title={t("contentScheduler.presets.global.title")}
      rightSlot={
        <span className="flex items-center gap-2">
          <span className="text-[11px] text-white/55 flex items-center gap-1">
            {t("contentScheduler.presets.global.autoPublish")}
            <HelpCircle size={11} className="text-white/30" />
          </span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onChange({ ...value, autoPublish: !value.autoPublish });
            }}
            className={`relative w-9 h-5 rounded-full transition-colors ${value.autoPublish ? "bg-blue-500" : "bg-white/[0.12]"}`}
          >
            <span
              className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white transition-transform ${value.autoPublish ? "translate-x-4" : ""}`}
            />
          </button>
        </span>
      }
    >
      <PresetToggle
        label={
          <span className="inline-flex items-center gap-1.5">
            <Link2 size={12} className="text-white/50" />
            {t("contentScheduler.presets.global.urlShortener")}
          </span>
        }
        description={t("contentScheduler.presets.global.urlShortenerHint")}
        checked={value.useUrlShortener}
        onChange={(next) => onChange({ ...value, useUrlShortener: next })}
      />
      <div className="rounded-lg border border-dashed border-white/[0.1] px-3 py-2.5">
        <div className="text-[11px] font-semibold text-white/70">
          {t("contentScheduler.presets.global.smartLinks")}
        </div>
        <div className="text-[11px] text-white/40 mt-0.5 leading-snug">
          {t("contentScheduler.presets.global.smartLinksHint")}
        </div>
      </div>
    </PresetSection>
  );
}
